import { render, staticRenderFns } from "./ProviderCreateUpdate.vue?vue&type=template&id=53adf5e6&scoped=true&"
import script from "./ProviderCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProviderCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCreateUpdate.vue?vue&type=style&index=0&id=53adf5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53adf5e6",
  null
  
)

export default component.exports